module.exports = __webpack_public_path__ + "static/media/camar.592dba40.jpg";